import React from "react";
import type { ReactNode } from "react";
import { EmailBuilderSettingsAccordion } from "../accordion/EmailBuilderSettingsAccordion";
import type { EmailBuilderSettingsSectionActivation } from "../settingsSectionActivation";

export type SettingSectionProps = {
  sectionId: string;
  title: string;
  titleActions?: ReactNode;
  children: ReactNode;
  activation?: EmailBuilderSettingsSectionActivation;
};

export function SettingSection({
  sectionId,
  title,
  titleActions,
  children,
  activation,
}: SettingSectionProps) {
  return (
    <EmailBuilderSettingsAccordion.Section
      sectionId={sectionId}
      title={title}
      headerActions={titleActions}
      activation={activation}
    >
      {children}
    </EmailBuilderSettingsAccordion.Section>
  );
}
